import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  SetState,
  addFilter,
  getCategories,
  getProducts,
  getProductBrands,
  getAllSubCategories,
  clearProduct,
  aiSearchProducts,
} from "../../../redux/reducers/auth";
import { Collapse, Col, Input, Row, InputGroup, InputGroupAddon, Button } from "reactstrap";
import { debounce } from "lodash";
import "./search.css";
import InfiniteScroll from "react-infinite-scroll-component";
import SkyLight from "react-skylight";
import { AppHeader } from "@coreui/react";
import DefaultFooter from "../../Footer/DefaultFooter";
import DefaultHeader from "../../Header/DefaultHeader";
import ProductPreviewBox from "../Home/ProductPreviewBox";
import { IoIosArrowDropdown } from "react-icons/io";
import { trackSellerPageView } from "../../../helpers/analyticsTracker";

const Search = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const yinnPriceModal = useRef(null);
  const searchField = useRef(null);
  const { translationState, allWebContent } = useSelector(
    (state) => state.user
  );
  const {
    count,
    filters,
    productCategories,
    products,
    brands,
    allSubCategories,
    userLanguage,
    token,
    aiSearchLoading,
    aiSearchType,
  } = useSelector((state) => state.auth);

  // AI Search Instructional Text Translations
  const aiSearchTranslations = {
    en: "Tell us what you are looking for and YINN will find it for you",
    fr: "Dites-nous ce que vous cherchez et YINN le trouvera pour vous",
    es: "Dinos qué estás buscando y YINN lo encontrará para ti",
    zh: "告诉我们您在寻找什么，YINN将为您找到它",
    pt: "Diga-nos o que você está procurando e YINN encontrará para você",
    ar: "أخبرنا عما تبحث عنه وسيجده YINN لك"
  };
  const [hasMoreItems, setHasMoreItems] = useState(true);
  const [searchProduct, setSearchProduct] = useState({
    name: "",
    mainCategory: [],
    subCategory: [],
    brand: [],
  });


  const [mainCategoryChecked, setMainCategoryChecked] = useState([]);
  const [subCategoryChecked, setSubCategoryChecked] = useState([]);
  const [brandChekboxes, setBrandChekboxes] = useState([]); // for brand checkboxes

  const pageNo = filters?.find((item) => item.field === "pageNo");
  const ShopContent = allWebContent?.[0]?.shop;
  const shopTranslation =
    translationState?.[0]?.translations?.shop?.[userLanguage];

  useEffect(() => {
    dispatch(clearProduct());
    const type = new URLSearchParams(location.search).get("type");
    const defaultFilters = [
      { field: "pageNo", value: 1 },
      { field: "perPage", value: 10 },
    ];
    if (type && type == "digital") {
      defaultFilters.push({ field: "type", value: "digital" });
    }
    if (type && type == "residency-swap") {
      defaultFilters.push({ field: "productType", value: "residencySwap" });
    }
    dispatch(SetState({ field: "filters", value: defaultFilters }));
    dispatch(getProducts());
    dispatch(getProductBrands());
    dispatch(getCategories());
    dispatch(getAllSubCategories());
  }, [token]);

  useEffect(() => {
    const textValue = new URLSearchParams(location.search).get("txt");
    if (textValue) {
      searchElement(textValue);
      searchField.current.value = textValue;
    }
  }, [location]);

  useEffect(() => {
    if (products?.length == count) {
      setHasMoreItems(false);
    } else if (products?.length <= count) {
      setHasMoreItems(true);
    }
  }, [products]);

  // useEffect(() => {
  //   if (filters?.length) {
  //     const filtersObject = searchProduct;
  //     for (let i = 0; i < filters.length; i++) {
  //       const { field, value } = filters[i];
  //       filtersObject[field] = value;
  //     }
  //   }
  // }, [filters]);

  const searchElement = debounce(async (txt) => {
    dispatch(clearProduct());

    // If search text is empty, show all products
    if (!txt.trim()) {
      dispatch(addFilter({ field: "pageNo", value: 1 }));
      dispatch(addFilter({ field: "search", value: "" }));
      dispatch(addFilter({ field: "userLanguage", value: userLanguage }));
      dispatch(getProducts());
      return;
    }

    // Always use AI search for all queries
    try {
      await dispatch(aiSearchProducts(txt));
    } catch (error) {
      console.error('AI search failed:', error);
      // Fallback to traditional search if AI search fails
      dispatch(addFilter({ field: "pageNo", value: 1 }));
      dispatch(addFilter({ field: "search", value: txt }));
      dispatch(addFilter({ field: "userLanguage", value: userLanguage }));
      dispatch(getProducts());
    }
  }, 500);

  const handleSearchClick = () => {
    const searchValue = searchField.current?.value;
    searchElement(searchValue || "");
  };

  const fetchData = () => {
    if (products?.length <= count) {
      setHasMoreItems(true);
      dispatch(addFilter({ field: "pageNo", value: pageNo?.value + 1 }));
      dispatch(getProducts());
    } else {
      setHasMoreItems(false);
    }
  };

  const handleBrandCheckboxChanges = (brand) => {
    let newFilters = [];
    const brandFilter = filters?.find((item) => item.field === "brand");
    if (brandFilter) {
      newFilters = [...brandFilter.value];
      const newBrand = newFilters?.findIndex((item) => item === brand);
      if (newBrand !== -1) {
        newFilters.splice(newBrand, 1);
      } else {
        newFilters.push(brand);
      }
    } else {
      newFilters.push(brand);
    }
    // Toggle the brand
    setBrandChekboxes((prev) => {
      const newChecked = [...prev];
      const index = newChecked.indexOf(brand);
      if (index === -1) {
        newChecked.push(brand);
      } else {
        newChecked.splice(index, 1);
      }
      return newChecked;
    });
    setHasMoreItems(true);
    dispatch(clearProduct());
    dispatch(addFilter({ field: "pageNo", value: 1 }));
    dispatch(addFilter({ field: "brand", value: newFilters }));
    dispatch(getProducts());
  };

  const changeCategory = (category) => {
    let newFilters = [];
    const categoryFilter = filters?.find(
      (item) => item.field === "mainCategory"
    );
    if (categoryFilter) {
      newFilters = [...categoryFilter.value];
      const newCategory = newFilters?.findIndex((item) => item === category);
      if (newCategory !== -1) {
        newFilters.splice(newCategory, 1);
      } else {
        newFilters.push(category);
      }
    } else {
      newFilters.push(category);
    }
    // Toggle the category
    setMainCategoryChecked((prev) => {
      const newChecked = [...prev];
      const index = newChecked.indexOf(category);
      if (index === -1) {
        newChecked.push(category);
      } else {
        newChecked.splice(index, 1);
      }
      return newChecked;
    });
    setHasMoreItems(true);
    dispatch(clearProduct());
    dispatch(addFilter({ field: "pageNo", value: 1 }));
    dispatch(addFilter({ field: "mainCategory", value: newFilters }));
    dispatch(getProducts());
  };
  const changeMainCategory = (event) => {
    const category = event.target.value;
    setHasMoreItems(true);
    dispatch(clearProduct());
    dispatch(addFilter({ field: "pageNo", value: 1 }));
    dispatch(addFilter({ field: "mainCategory", value: [category] }));
    dispatch(getProducts());
  };

  const handleSubCategoryCheckboxChanges = (category) => {
    let newFilters = [];
    const categoryFilter = filters?.find(
      (item) => item.field === "subCategory"
    );
    if (categoryFilter) {
      newFilters = [...categoryFilter.value];
      const newCategory = newFilters?.findIndex((item) => item === category);
      if (newCategory !== -1) {
        newFilters.splice(newCategory, 1);
      } else {
        newFilters.push(category);
      }
    } else {
      newFilters.push(category);
    }
    // Toggle the category
    setSubCategoryChecked((prev) => {
      const newChecked = [...prev];
      const index = newChecked.indexOf(category);
      if (index === -1) {
        newChecked.push(category);
      } else {
        newChecked.splice(index, 1);
      }
      return newChecked;
    });
    setHasMoreItems(true);
    dispatch(clearProduct());
    dispatch(addFilter({ field: "pageNo", value: 1 }));
    dispatch(addFilter({ field: "subCategory", value: newFilters }));
    dispatch(getProducts());
  };

  const viewProduct = (id, productType, digitalType) => {
    const selected = (products || []).find((p) => p._id === id);
    const sellerId = selected?.sellerId?._id || selected?.sellerId || "";
    if (sellerId) {
      trackSellerPageView({
        sellerId,
        productId: id,
        pageType:
          productType === "digital" ? "digital_product_detail" : "product_detail",
        productType: productType || "",
        digitalType: digitalType || "",
      });
    }
    const isViewTv = ["movie", "series", "theater", "music"].includes(
      digitalType
    );
    if (!isViewTv)
      history.push(
        `/${productType == "digital" ? "digitalproduct" : "productdetail"
        }/${id}`
      );
    else
      history.push(
        `/${productType == "digital" ? "viewtv" : "productdetail"}/${id}`
      );
  };

  return (
    <div className="animated fadeIn">
      <div className="app" style={{ backgroundColor: "#f6f6f6" }}>
        <Row>
          <AppHeader fixed>
            <DefaultHeader />
          </AppHeader>
        </Row>
        <main role="main" aria-label="Product search and browsing">
        <InfiniteScroll
          pageStart={1}
          dataLength={products?.length || 10}
          next={fetchData}
          hasMore={hasMoreItems && !aiSearchLoading}
          loader={
            <div className="loader" key={0}>
              <i
                className="fas fa-spinner fa-pulse fa-1x"
                style={{ marginTop: "80px" }}
                role="presentation"
              ></i>
            </div>
          }
          endMessage={
            <p style={{ textAlign: "center", marginTop: "80px" }}>
              <b>
                {shopTranslation?.messgaeTwo
                  ? shopTranslation?.messgaeTwo
                  : ShopContent?.messgaeTwo}
              </b>
            </p>
          }
        >
          <div className="d-flex" style={{ width: "calc(100% - 40px)", marginLeft: "20px", marginRight: "20px" }}>
            <div style={{ width: "100%" }}>
              <Row
                style={{
                  marginTop: 75,
                  paddingTop: 40,
                  paddingLeft: 20,
                  paddingRight: 20,
                }}
                className="d-flex search-field-row"
              >
                {/* AI Search Instructional Text */}
                <div className="w-100 text-center mb-3">
                  <small className="text-muted">
                    <i className="fa fa-lightbulb-o mr-1" role="presentation"></i>
                    {aiSearchTranslations[userLanguage] || aiSearchTranslations.en}
                  </small>
                </div>
                <InputGroup className="main-search-input-group">
                  <Input
                    className="main-search-input"
                    placeholder={
                      shopTranslation?.search
                        ? shopTranslation?.search
                        : ShopContent?.search
                    }
                    ref={searchField}
                    onChange={(e) => searchElement(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSearchClick();
                      }
                    }}
                    aria-label="Search for products"
                    id="main-search-input"
                  />
                  <InputGroupAddon addonType="append" className="search-button-addon">
                    <Button
                      type="button"
                      className="search-button"
                      onClick={handleSearchClick}
                      aria-label="Search products"
                    >
                      <i className="fa fa-search search-icon" role="presentation"></i>
                    </Button>
                  </InputGroupAddon>
                </InputGroup>
              </Row>

              {/* Mobile Categories Section - Shows first on mobile */}
              <Row className="pt-5 d-block d-xl-none" style={{ marginLeft: 0, marginRight: 0 }}>
                <Col xs="12" style={{ paddingLeft: 0, paddingRight: 0, marginBottom: 20 }}>
                  <BrowseCategories
                    categorries={productCategories}
                    subCategories={allSubCategories || []}
                    brands={brands}
                    searchData={searchProduct}
                    handleCategoryCheckboxChanges={changeCategory}
                    handleSubCategoryCheckboxChanges={
                      handleSubCategoryCheckboxChanges
                    }
                    handleBrandCheckboxChanges={handleBrandCheckboxChanges}
                    mainCategoryChecked={mainCategoryChecked}
                    subCategoryChecked={subCategoryChecked}
                    brandChekboxes={brandChekboxes}
                  />
                </Col>
              </Row>

              {/* Main Content Row */}
              <Row className="pt-5 d-flex" style={{ marginLeft: 0, marginRight: 0 }}>
                {/* Desktop Categories Sidebar - Hidden on mobile */}
                <Col xs="12" xl="3" className="d-none d-xl-block" style={{ paddingLeft: 0, paddingRight: 10 }}>
                  {/* <Row style={{ marginBottom: 30 }}>
                    <SelectedCategories
                      categorries={productCategories}
                      subCategories={allSubCategories || []}
                      brands={brands}
                      searchData={searchProduct}
                      handleBrandCheckboxChanges={handleBrandCheckboxChanges}
                      handleCategoryCheckboxChanges={changeCategory}
                      handleSubCategoryCheckboxChanges={
                        handleSubCategoryCheckboxChanges
                      }
                    />
                  </Row> */}
                  <Row>
                    <BrowseCategories
                      categorries={productCategories}
                      subCategories={allSubCategories || []}
                      brands={brands}
                      searchData={searchProduct}
                      handleCategoryCheckboxChanges={changeCategory}
                      handleSubCategoryCheckboxChanges={
                        handleSubCategoryCheckboxChanges
                      }
                      handleBrandCheckboxChanges={handleBrandCheckboxChanges}
                      mainCategoryChecked={mainCategoryChecked}
                      subCategoryChecked={subCategoryChecked}
                      brandChekboxes={brandChekboxes}
                    />
                  </Row>
                </Col>

                {/* Products Section */}
                <Col xs="12" xl="9" style={{ paddingLeft: 10, paddingRight: 0 }}>
                  <Row className="category-dropdown-area ">
                    <label className="main-category-label" style={{ fontSize: "18px" }}>
                      {shopTranslation?.mainCategory
                        ? shopTranslation?.mainCategory
                        : ShopContent?.mainCategory}
                    </label>
                    <select
                      onChange={changeMainCategory}
                      className="category-dropdown"
                      aria-label="Select main category"
                      id="main-category-select"
                    >
                      <option value={"all"}>
                        {shopTranslation?.allCategory
                          ? shopTranslation?.allCategory
                          : ShopContent?.allCategory}
                      </option>
                      {productCategories?.map((item, i) => (
                        <option value={item._id} key={i}>
                          {userLanguage == "en"
                            ? item.name
                            : item.translatedArray.map((tr) => {
                              if (tr.language == userLanguage) {
                                return tr.name;
                              }
                            })}
                          {/* {item.name} */}
                        </option>
                      ))}
                    </select>
                  </Row>
                  <Row className="product-area ">
                    <Col xs="12">
                      <Row
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          height: 100,
                          paddingLeft: "5%",
                          paddingRight: "5%",
                        }}
                      >
                        <div>
                          <strong style={{ color: "#6C6C6C", fontSize: "18px" }}>
                            {searchProduct?.name
                              ? `Search results for "${searchProduct?.name}" (AI Search)`
                              : `${shopTranslation?.allProduct
                                ? shopTranslation?.allProduct
                                : ShopContent?.allProduct
                              }`}
                          </strong>
                        </div>
                        <button
                          onClick={() => yinnPriceModal.current.show()}
                          style={{ 
                            color: "#9baed4", 
                            cursor: "pointer", 
                            fontSize: "16px",
                            background: "none",
                            border: "none",
                            padding: 0,
                            textDecoration: "underline"
                          }}
                          aria-label="View price information"
                        >
                          {shopTranslation?.price
                            ? shopTranslation?.price
                            : ShopContent?.price}
                        </button>
                      </Row>

                      <Row style={{ marginLeft: 0, marginRight: 0 }}>
                        <Col xs="12" style={{ paddingLeft: 0, paddingRight: 0 }}>
                          {aiSearchLoading ? (
                            <div style={{ 
                              display: "flex", 
                              justifyContent: "center", 
                              alignItems: "center", 
                              height: "200px",
                              width: "100%"
                            }}>
                              <i className="fas fa-spinner fa-pulse fa-2x" style={{ color: "#6C6C6C" }} role="presentation"></i>
                            </div>
                          ) : (
                            <div
                              className="product-cards-container"
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                width: "100%",
                              }}
                            >
                              {products?.map(
                                (product, index) =>
                                  product.status === "Active" && (
                                    <ProductPreviewBox
                                      key={index}
                                      product={product}
                                      viewProduct={() => {
                                        viewProduct(
                                          product._id,
                                          product.productType,
                                          product.digitalType
                                        );
                                      }}
                                    />
                                  )
                              )}
                              {products?.length <= 0 && (
                                <div style={{ 
                                  display: "flex", 
                                  justifyContent: "center", 
                                  alignItems: "center", 
                                  height: "200px",
                                  width: "100%"
                                }}>
                                  <h3 style={{ textAlign: "center", margin: 0 }}>
                                    {shopTranslation?.message
                                      ? shopTranslation?.message
                                      : ShopContent?.message}
                                  </h3>
                                </div>
                              )}
                            </div>
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        </InfiniteScroll>
        <SkyLight
          hideOnOverlayClicked
          ref={yinnPriceModal}
          title={
            shopTranslation?.popUpHeading
              ? shopTranslation?.popUpHeading
              : ShopContent?.popUpHeading
          }
        >
          {shopTranslation?.popUp ? shopTranslation?.popUp : ShopContent?.popUp}
        </SkyLight>

        </main>
        <DefaultFooter />
      </div>
    </div>
  );
};

export default Search;

const SelectedCategories = (props) => {
  const { translationState, allWebContent } = useSelector(
    (state) => state.user
  );
  const { userLanguage } = useSelector((state) => state.auth);
  const ShopContent = allWebContent?.[0]?.shop;
  const shopTranslation =
    translationState?.[0]?.translations?.shop?.[userLanguage];
  const {
    categorries,
    subCategories,
    brands,
    searchData,
    handleBrandCheckboxChanges,
    handleCategoryCheckboxChanges,
    handleSubCategoryCheckboxChanges,
  } = props;

  const closeCategory = (catName) => {
    handleCategoryCheckboxChanges(catName);
  };

  const closeSubCategory = (catName) => {
    handleSubCategoryCheckboxChanges(catName);
  };

  const [isOpen, setIsOpen] = useState(true);

  return (
    <Row
      className="selected-categories "
      style={{ display: "flex", justifyContent: "space-between" }}
    >
      <Col xs="12">
        <Row
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: 50,
            paddingLeft: "3%",
            paddingRight: "3%",
          }}
        >
          <div>
            <strong style={{ color: "#575757" }}>
              {shopTranslation?.selected
                ? shopTranslation?.selected
                : ShopContent?.selected}
            </strong>
          </div>

          <IoIosArrowDropdown
            size={20}
            onClick={() => {
              setIsOpen(!isOpen);
            }}
            className="expand-button"
            aria-label={isOpen ? "Collapse selected filters" : "Expand selected filters"}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                setIsOpen(!isOpen);
              }
            }}
          />
        </Row>
        <Row>
          <div
            style={{
              backgroundColor: "#f6f6f6",
              width: "100%",
              height: 2,
              marginLeft: 20,
              marginRight: 20,
            }}
          />
        </Row>
        <Collapse isOpen={isOpen}>
          <Row className="pt-4">
            <Col xs="12 d-flex flex-wrap">
              {searchData?.brand?.map((brandName, i) => {
                return (
                  <div key={`brand-${i}`} className="filter-tag mr-3 mb-2">
                    <div className="filter-tag-text-area">
                      <div className="filter-tag-subtitle " role="heading" aria-level="3">brand</div>
                      <div className="filter-tag-title " role="heading" aria-level="4">{brandName}</div>
                    </div>
                    <button
                      className="filter-tag-close"
                      onClick={() => handleBrandCheckboxChanges(brandName)}
                      aria-label={`Remove ${brandName} brand filter`}
                    />
                  </div>
                );
              })}
              {searchData?.mainCategory?.map((catName, i) => {
                const category = categorries?.find(
                  (item) => item._id == catName
                );
                return (
                  category && (
                    <div key={`main-cat-${i}`} className="filter-tag mr-3 mb-2">
                      <div className="filter-tag-text-area">
                        <div className="filter-tag-subtitle " role="heading" aria-level="3">category</div>
                        <div className="filter-tag-title " role="heading" aria-level="4">
                          {category?.name}
                        </div>
                      </div>
                      <button
                        className="filter-tag-close"
                        onClick={() => {
                          closeCategory(category?._id);
                        }}
                        aria-label={`Remove ${category?.name} category filter`}
                      />
                    </div>
                  )
                );
              })}
              {searchData?.subCategory?.map((catName, i) => {
                const category = subCategories?.find(
                  (item) => item._id == catName
                );
                return (
                  category && (
                    <div key={`sub-cat-${i}`} className="filter-tag mr-3 mb-2">
                      <div className="filter-tag-text-area">
                        <div className="filter-tag-subtitle " role="heading" aria-level="3">sub category</div>
                        <div className="filter-tag-title " role="heading" aria-level="4">
                          {category?.name}
                        </div>
                      </div>
                      <button
                        className="filter-tag-close"
                        onClick={() => {
                          closeSubCategory(category?._id);
                        }}
                        aria-label={`Remove ${category?.name} subcategory filter`}
                      />
                    </div>
                  )
                );
              })}
              {searchData.brand?.length === 0 &&
                searchData.mainCategory?.length === 0 &&
                searchData.subCategory?.length === 0 &&
                shopTranslation?.filterApplied
                ? shopTranslation?.filterApplied
                : "No filters applied"}
            </Col>
          </Row>
        </Collapse>
      </Col>
    </Row>
  );
};

const BrowseCategories = (props) => {
  const { translationState, allWebContent } = useSelector(
    (state) => state.user
  );
  const { userLanguage } = useSelector((state) => state.auth);
  const ShopContent = allWebContent?.[0]?.shop;
  const shopTranslation =
    translationState?.[0]?.translations?.shop?.[userLanguage];
  const {
    categorries,
    subCategories,
    brands,
    searchData,
    handleBrandCheckboxChanges,
    handleCategoryCheckboxChanges,
    handleSubCategoryCheckboxChanges,
    mainCategoryChecked,
    subCategoryChecked,
    brandChekboxes,
  } = props;
  const [isCategoriesOpen, setIsCategoriesOpen] = useState(true);
  const [isSubCategoriesOpen, setIsSubCategoriesOpen] = useState(false);
  const [isBrandOpen, setIsBrandOpen] = useState(false);

  return (
    <React.Fragment>
      <div className="category-box-wrapper">
        <Row
          className="browse-categories   "
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Col xs="12">
            <Row
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                height: 50,
                paddingLeft: "3%",
                paddingRight: "3%",
              }}
            >
              <div>
                <strong style={{ color: "#575757", fontSize: "18px" }}>
                  {shopTranslation?.categories
                    ? shopTranslation?.categories
                    : ShopContent?.categories}
                </strong>
              </div>

              <IoIosArrowDropdown
                size={20}
                onClick={() => {
                  setIsCategoriesOpen(!isCategoriesOpen);
                }}
                className="expand-button"
                aria-label={isCategoriesOpen ? "Collapse categories" : "Expand categories"}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    setIsCategoriesOpen(!isCategoriesOpen);
                  }
                }}
              />
            </Row>
            <Collapse isOpen={isCategoriesOpen}>
              <Row>
                <div
                  style={{
                    backgroundColor: "#f6f6f6",
                    width: "100%",
                    height: 2,
                    marginLeft: 20,
                    marginRight: 20,
                  }}
                />
              </Row>
              <Row className="pt-4">
                <Col xs="12 d-flex flex-wrap">
                  <ul className="radio-list pl-3">
                    {categorries?.map((item, index) => (
                      <li key={index}>
                        <Input
                          type="checkbox"
                          id={`cat-${item._id}`}
                          className="radio-cursor"
                          checked={mainCategoryChecked?.includes(item._id)}
                          onChange={(e) =>
                            handleCategoryCheckboxChanges(item._id)
                          }
                          aria-label={`Filter by ${userLanguage == "en" ? item.name : item.translatedArray.find(tr => tr.language == userLanguage)?.name || item.name} category`}
                        />
                        <label
                          className="filter-list-item"
                          htmlFor={`cat-${item._id}`}
                          style={{ marginLeft: "10px" }}
                        >
                          {userLanguage == "en"
                            ? item.name
                            : item.translatedArray.map((tr) => {
                              if (tr.language == userLanguage) {
                                return tr.name;
                              }
                            })}
                          {/* {item.name} */}
                        </label>
                      </li>
                    ))}
                  </ul>
                </Col>
              </Row>
            </Collapse>
          </Col>
        </Row>

        <Row
          className="browse-categories "
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Col xs="12">
            <Row
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                height: 50,
                paddingLeft: "3%",
                paddingRight: "3%",
              }}
            >
              <div>
                <strong style={{ color: "#575757", fontSize: "18px" }}>
                  {shopTranslation?.subcategories
                    ? shopTranslation?.subcategories
                    : ShopContent?.subcategories}
                </strong>
              </div>
              <IoIosArrowDropdown
                size={20}
                onClick={() => {
                  setIsSubCategoriesOpen(!isSubCategoriesOpen);
                }}
                className="expand-button"
                aria-label={isSubCategoriesOpen ? "Collapse subcategories" : "Expand subcategories"}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    setIsSubCategoriesOpen(!isSubCategoriesOpen);
                  }
                }}
              />
            </Row>
            <Collapse isOpen={isSubCategoriesOpen}>
              <Row>
                <div
                  style={{
                    backgroundColor: "#f6f6f6",
                    width: "100%",
                    height: 2,
                    marginLeft: 20,
                    marginRight: 20,
                  }}
                />
              </Row>
              <Row className="pt-4">
                <Col xs="12 d-flex flex-wrap">
                  <ul className="radio-list pl-3">
                    {subCategories?.map((item, index) => (
                      <li key={`subcat-li-${index}`}>
                        <Input
                          type="checkbox"
                          id={`subcat-${item._id}`}
                          className="radio-cursor"
                          checked={subCategoryChecked?.includes(item._id)}
                          value={item.name}
                          onChange={(e) =>
                            handleSubCategoryCheckboxChanges(item._id)
                          }
                          aria-label={`Filter by ${userLanguage == "en" ? item.name : item.translatedArray.find(tr => tr.language == userLanguage)?.name || item.name} subcategory`}
                        />
                        <label
                          className="filter-list-item"
                          htmlFor={`subcat-${item._id}`}
                          style={{ marginLeft: "10px" }}
                        >
                          {userLanguage == "en"
                            ? item.name
                            : item.translatedArray.map((tr) => {
                              if (tr.language == userLanguage) {
                                return tr.name;
                              }
                            })}
                          {/* {item.name} */}
                        </label>
                      </li>
                    ))}
                  </ul>
                </Col>
              </Row>
            </Collapse>
          </Col>
        </Row>

        <Row
          className="browse-categories"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Col xs="12">
            <Row
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                height: 50,
                paddingLeft: "3%",
                paddingRight: "3%",
              }}
            >
              <div>
                <strong style={{ color: "#575757", fontSize: "18px" }}>
                  {shopTranslation?.brand
                    ? shopTranslation?.brand
                    : ShopContent?.brand}
                </strong>
              </div>
              <IoIosArrowDropdown
                size={20}
                onClick={() => {
                  setIsBrandOpen(!isBrandOpen);
                }}
                className="expand-button"
                aria-label={isBrandOpen ? "Collapse brands" : "Expand brands"}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    setIsBrandOpen(!isBrandOpen);
                  }
                }}
              />
            </Row>
            <Collapse isOpen={isBrandOpen}>
              <Row>
                <div
                  style={{
                    backgroundColor: "#f6f6f6",
                    width: "100%",
                    height: 2,
                    marginLeft: 20,
                    marginRight: 20,
                  }}
                />
              </Row>
              <Row className="pt-4">
                <Col xs="12">
                  <ul className="radio-list pl-3">
                    {brands?.map((item, index) => (
                      <li key={index}>
                        <Input
                          type="checkbox"
                          id={`brand-${index}`}
                          className="radio-cursor"
                          checked={brandChekboxes?.includes(item)}
                          onChange={(e) => handleBrandCheckboxChanges(item)}
                          aria-label={`Filter by ${item} brand`}
                        />
                        <label
                          className="filter-list-item"
                          htmlFor={`brand-${index}`}
                          style={{ marginLeft: "10px" }}
                        >
                          {item}
                        </label>
                      </li>
                    ))}
                  </ul>
                </Col>
              </Row>
            </Collapse>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};
